export default{
  carousels:[
    {
      id: 0,
      title: '1944, Wileńszczyzna.',
      text: 'Przysięga grupy żołnierzy z 5 Brygady Partyzanckiej AK, prawdopodobnie z 1 komp. Przysięgę odbiera kapelan 5 Brygady ks. Aleksander Grabowski ps. "Ignacy". Fot. Sergiusz Sprudin, zbiór zdjęć Janusza Chorążaka',
      img: "/home/main_1.jpg"
    },
    {
      id: 1,
      title: '1944, Turgiele, Wileńszczyzna',
      text: 'Honorowa straż 3 Wileńskiej Brygady Partyzanckiej AK przy grobie pańskim. Fot. Leonard Siemaszko ps. „Długi”, kolekcja Wincentego Borodziewicza, zbiory Ośrodka KARTA, przekazała Wanda Borodziewicz',
      img: "/home/main_2.jpg"
    },
    {
      id: 2,
      title: '9.04.1944, Turgiele, Wileńszczyzna.',
      text: 'Kawaleria 3 Brygady Armii Krajowej – przed żołnierzami dowódca szwadronu kawalerii porucznik Władysław Kitowski ps. „Grom”, (od lewej w kolumnie) partyzant Ludwik Błuś ps. „Smutny”, zastępca dowódcy podporucznik Tadeusz Duszyński (?) ps. „Wołodyjowski”, partyzant Kazimierz Buncler ps. "Mik", partyzant Izbicki ps. „Hel”. Fot. NN, kolekcja Wincentego Borodziewicza, zbiory Ośrodka KARTA, przekazała Wanda Borodziewicz',
      img: "/home/main_3.jpg"
    },
    {
      id: 3,
      title: '9.04.1944, Turgiele.',
      text: 'Komendant Okręgu Wileńskiego Armii Krajowej podpułkownik Aleksander Krzyżanowski ps. „Wilk” dekoruje odznaczeniami oficerów i żołnierzy 3 Wileńskiej Brygady Partyzanckiej. W szeregu przed komendantem stoją (od lewej)” porucznik Gracjan Fróg ps. Szczerbiec, lekarz brygady Lech Iwanowski, dowódca plutonu Romuald Rajs. Fot. NN, kolekcja Wincentego Borodziewicza, zbiory Ośrodka KARTA, przekazała Wanda Borodziewicz',
      img: "/home/main_4.jpg"
    },
    {
      id: 4,
      title: 'Luty 1944',
      text: 'Partyzanci 1 plutonu 6 Wileńskiej Samodzielnej Brygady Partyzanckiej Armii Krajowej w marszu. Pluton prowadzi Wincenty Borodziewicz ps. „Szkrab”. Fot. NN, kolekcja Wincentego Borodziewicza, zbiory Ośrodka KARTA, przekazała Wanda Borodziewicz',
      img: "/home/main_5.jpg"
    },
    {
      id: 5,
      title: 'Styczeń 1944, Wileńszczyzna.',
      text: '6 Wileńska Samodzielna Brygada Partyzancka Armii Krajowej. Fot. NN, kolekcja Wincentego Borodziewicza, zbiory Ośrodka KARTA, przekazała Wanda Borodziewicz',
      img: "/home/main_6.jpg"
    },
    {
      id: 6,
      title: 'Lipiec 1944, Puszcza Rudnicka. ',
      text: 'Major Czesław Dębicki ps. Jerema dokonuje odprawy partyzantów swojego zgrupowania. Fot. NN, kolekcja Wincentego Borodziewicza, zbiory Ośrodka KARTA, przekazała Wanda Borodziewicz',
      img: "/home/main_7.jpg"
    },
    {
      id: 7,
      title: '17.07.1944, Czarny Bór, pow. Wileńsko-Trocki.',
      text: 'Oddział partyzancki Bazy z Kedywu Komendy Okręgu Wileńskiego AK po akcji "Burza". Uroczystość przed kościołem z udziałem duchowieństwa i okolicznej ludności cywilnej. Kobieta wręcza kwiaty dowódcy oddziału plut. pchor. Andrzejowi Święcickiemu "Fryczowi". Fot. Zygmunt Zniszczyński, zbiory Ośrodka KARTA',
      img: "/home/main_8.jpg"
    }
  ]
}



// WEBPACK FOOTER //
// ./src/models/home.js